import createSagaMiddleware, {Saga} from 'redux-saga';
import {Reducer} from 'redux';
import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import {logError} from '@yandex-int/pythia-libs';

const sagaMiddleware = createSagaMiddleware({
    onError: (err: Error, {sagaStack}) => {
        logError({err, additional: {sagaStack}});
    }
});

interface GetStoreParamsProps {
    reducer: Reducer;
    rootSaga: Saga;
    sagaMw?: any;
    additonalMiddlewares?: any[];
}
export default function getStore<T>(
    preloadedState = {},
    {
        reducer,
        rootSaga,
        sagaMw = sagaMiddleware,
        additonalMiddlewares = [...getDefaultMiddleware({thunk: false})]
    }: GetStoreParamsProps
) {
    const store = configureStore<T>({
        reducer,
        preloadedState,
        middleware: [sagaMw, ...additonalMiddlewares]
    });

    sagaMw.run(rootSaga);

    return store;
}
